import { useTranslation } from 'next-i18next';
import { VFC } from 'react';

import CustomButton from '@/components/CustomButton';

import styles from './FailedAndRetry.module.scss';

type Props = {
  isProcessing?: boolean;
  onRetryButtonClick(): void;
};

const FailedAndRetry: VFC<Props> = ({
  isProcessing = false,
  onRetryButtonClick,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.failedAndRetry}>
      <p>{t('failedAndRetry.errorMessage')}</p>
      <CustomButton onClick={onRetryButtonClick} loading={isProcessing}>
        {t('failedAndRetry.retry')}
      </CustomButton>
    </div>
  );
};

export default FailedAndRetry;
